import { GET_EVENT_CREW } from 'actions/Types';

function eventCrew(state = [], action) {
  if (action.type === `${GET_EVENT_CREW}_SUCCESS`) {
    return action.payload;
  }

  return state;
}

export default eventCrew;
